/* ============================================================
   CULT RACING — SIZE GUIDE POPUP

   A "Size guide" button sits beside each garment group rule on the
   rack. Clicking it opens the chart for that garment.

   Additive, like the lightbox: its own asset pair, loaded after
   drop-page.js, touching nothing that file owns. Both files are
   named for the feature rather than the page so promoting them to
   the other drop pages is a copy plus two tags.

   The chart markup is server-rendered in the snippet, one panel per
   garment, so there is no fetch and nothing to wait for — the popup
   opens instantly and works with a dead network.
   ============================================================ */
(function () {
  "use strict";

  var box = document.getElementById("sizeGuide");
  if (!box) return;

  /* ---- put a button on every product -------------------------------
     Mudit moved this off the group rule and onto each piece (2026-08-05),
     so the guide is beside the product you are looking at instead of a
     header that has scrolled away.

     Injected rather than rendered, because the lot markup lives in
     snippets/drop-lot.liquid which is SHARED with the Black Sheep page.
     Editing that would change a drop meant to stay frozen.

     A lot does not carry its own product type in the DOM, so the garment
     is read from the nearest `.rack__rule` ABOVE it — the rack always
     emits a rule before each group. Anything under a group with no chart
     (Accessories) simply gets no button. */
  function garmentOf(lot) {
    var el = lot.previousElementSibling;
    while (el) {
      if (el.classList && el.classList.contains("rack__rule")) {
        var lab = el.querySelector(".rack__rule-label");
        return lab ? lab.textContent.trim() : null;
      }
      el = el.previousElementSibling;
    }
    return null;
  }

  function keyOf(label) {
    return label ? label.toLowerCase().replace(/\s+/g, "-") : null;
  }

  [].slice.call(document.querySelectorAll(".rack__grid .lot")).forEach(function (lot) {
    var label = garmentOf(lot), key = keyOf(label);
    if (!key || !box.querySelector('[data-guide-panel="' + key + '"]')) return;

    var h = lot.querySelector(".lot__title");
    if (!h || h.querySelector(".sg-btn")) return;

    /* wrap the bare title text so it can flex against the button. An
       anonymous flex item cannot be given flex/min-width, and without
       min-width:0 a long title refuses to wrap and shoves the button out
       of the lot. textContent both ways, so nothing is ever parsed as HTML. */
    var text = h.textContent;
    h.textContent = "";
    var span = document.createElement("span");
    span.className = "lot__title-text";
    span.textContent = text;

    var b = document.createElement("button");
    b.type = "button";
    b.className = "sg-btn sg-btn--lot";
    b.setAttribute("data-guide", key);
    b.setAttribute("data-guide-label", label);
    b.setAttribute("aria-label", label + " size guide");
    b.textContent = "Size guide";

    h.appendChild(span);
    h.appendChild(b);
  });

  var btns = [].slice.call(document.querySelectorAll(".sg-btn"));
  if (!btns.length) return;

  var panel   = box.querySelector(".sg__panel");
  var titleEl = box.querySelector(".sg__title");
  var closeEl = box.querySelector(".sg__close");
  var panels  = [].slice.call(box.querySelectorAll("[data-guide-panel]"));
  var lastFocus = null;

  function open(which, label) {
    var found = false;
    panels.forEach(function (p) {
      var match = p.getAttribute("data-guide-panel") === which;
      p.hidden = !match;
      if (match) found = true;
    });
    /* no chart for this garment (accessories, or a type added later):
       say nothing rather than opening an empty box */
    if (!found) return;

    titleEl.textContent = (label || "Size") + " size guide";
    lastFocus = document.activeElement;
    box.hidden = false;
    document.documentElement.classList.add("sg-open");
    closeEl.focus();
  }

  function close() {
    if (box.hidden) return;
    box.hidden = true;
    document.documentElement.classList.remove("sg-open");
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  btns.forEach(function (b) {
    b.addEventListener("click", function (e) {
      e.preventDefault();
      open(b.getAttribute("data-guide"), b.getAttribute("data-guide-label"));
    });
  });

  closeEl.addEventListener("click", close);

  /* click anywhere off the panel closes. Bound on the overlay and
     filtered by containment, so a click that starts inside the panel
     (selecting a number in the table) never closes it. */
  box.addEventListener("click", function (e) {
    if (!panel.contains(e.target)) close();
  });

  document.addEventListener("keydown", function (e) {
    if (!box.hidden && e.key === "Escape") close();
  });
})();
